import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  hasError,
  ReactHookFormErrorMessage,
} from './ErrorFieldMessage';
import {
  FieldControl,
} from './CommonComponent';
import CustomTitleWithInput from './CustomTitleWithInput';

function InputFieldControl({
  name,
  title,
  rules,
  type = 'text',
  tips,
  value,
  useDefaultFieldName = false,
  setValue: customSetValue,
  optional,
  onFocus = () => {},
  customTitleClass,
  customClass,
  disabled,
  blurAction = (target) => {},
  useDefaultValue = true,
  unit,
  per,
  shortDescription,
  errorId=name,
  ...inputValues
}) {
  const { formState: { errors }, setValue, watch } = useFormContext();
  const fieldValue = (useDefaultFieldName ? watch(name) : value) || ""
  
  const onValueChange = (value) => {
    if (customSetValue) {
      customSetValue(value)
      return
    }
    setValue(name, value, {shouldDirty: true})
  }
  return (
    <FieldControl
      name={name}
      rules={rules}
      render={() => (
        <>
          <CustomTitleWithInput
            title={title}
            type={type}
            error={{ error: hasError(errors, name) }}
            setValue={onValueChange}
            focusChange={onFocus}
            defaultValue={fieldValue}
            extra={{ ...inputValues, value: fieldValue }}
            customTitleClass={customTitleClass}
            customClass={customClass}
            disabled={disabled}
            blurAction={blurAction}
            useDefaultValue={useDefaultValue}
            unit={unit}
            per={per}
            shortDescription={shortDescription}
            tips={tips}
          />
          {optional ? null : (
            <ReactHookFormErrorMessage errors={errors} id={errorId} />
          )}
        </>
      )}
    />
  );
}

export default InputFieldControl;